import { computed, type FunctionalComponent } from 'vue'
import { IconLabel } from 'components/icon-label'
import AssetCell from 'components/table/advanced/cells/asset'
import type { InfoBannerProps } from './type'
import { useResponsive } from '~/composables/useResponsive'

export const InfoBanner: FunctionalComponent<InfoBannerProps> = (props) => {

	const responsive = useResponsive();

	const filteredLabels = computed(() => {
		if (!props.labels || props.labels.length === 0) return []
		if (responsive.isPhone.value && props.labels.length > 1) {
			return props.labels.filter(label => label.type !== 'owned-by')
		}
		return props.labels
	})

	return (
		<div class="w-full mb-4 px-4 py-3 rounded-xs border border-gray-300 flex flex-row items-center gap-2 flex-wrap">
			<div class="flex-1 min-w-[180px]">
				<AssetCell
					title={props.title}
					subtitle={props.subtitle}
					icon={props.icon}
				/>
			</div>
			{
				filteredLabels.value && filteredLabels.value.length > 0 && (
					<div class="flex flex-row gap-4 flex-wrap min-w-0">
					{
						filteredLabels.value.map((label, index) => (
							<IconLabel
								key={index}
								icon={label.icon}
								text={label.text}
								border={label.border ?? true}
								textClass={label.textClass ?? 'truncate'}
								iconClass={label.iconClass}
							/>
						))}
					</div>
				)
			}
		</div>
	)
}

export default InfoBanner
